import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router keeps the scroll position when the route changes, which drops
// visitors halfway down the next page. This resets it on every navigation.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
